import React, { Component } from 'react'
import { TableCell, TableRow, Button } from "@mui/material";
import { Col, Container, Row, Modal, Form } from 'react-bootstrap';
import axios from "axios";
import ReactToPrint from 'react-to-print';
import Bardcode from '../../Components/JobForm/Bardcode';
import PhoneClinicGrid from '../../Components/PhoneClinicGrid';
import RowActions from '../../Components/PhoneClinicGrid/RowActions';
import { moneyCell } from '../../helper';
import StatusChip from './shared/StatusChip';

import AmountInput from '../../Components/AmountInput';
class Devices extends Component {
    constructor(props) {
        super(props);
        this.state = {

            InventoryList: [],
            showModal: false,
            showData: {
                "PC_SHP_INV_ID": "",
                "PC_SP_INV_SHID": "",
                "PC_SP_INV_PUR_ID": "",
                "ItemType": "",
                "ItemBrand": "",
                "ItemName": "",
                "ItemIMEI": "",
                "ItemDesc": "",
                "ItemRate": "",
                "ItemSellRate": "",
                "ItemStatus": ""
            },

            width: 1,
            height: 60,
            displayValue: true,
            text: "",
            fontOptions: "",
            font: "monospace",
            textAlign: "center",
            textPosition: "bottom",
            textMargin: 0,
            fontSize: 15,
            background: "#ffffff",
            lineColor: "#000000",
            margin: 10,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,

        };
        this.gridRef = React.createRef(null);
    }

    handleOpenModal(index) {
        let { InventoryList } = this.state;
        let showData = {}
        showData = InventoryList[index]
        this.setState({ showModal: true, showData })
    }

    async getData(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_GRP_ID: localStorage.getItem('PC_GRP_ID'),
            PC_SP_ID: localStorage.getItem('PC_GRP_ATT'),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/ShopModule/PCGetDeviceInventory.php`, formData);
        let serviceData = getAllInventory.data
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            pagination.totalItems = parseInt(serviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ InventoryList })
        this.props.toggleLoader(false)
    }

    render() {
        let { showData } = this.state
        return (
            <Container>
                <PhoneClinicGrid
                    title="DEVICE"
                    buttonLabel=""
                    onClickButton={() => { }}
                    getData={this.getData.bind(this)}
                    isEditable={true}
                    ref={this.gridRef}
                    tableHeadData={[
                        { label: "TYPE", isHidden: false },
                        { label: "BRAND", isHidden: false },
                        { label: "DEVICE", isHidden: false },
                        { label: "IMEI", isHidden: false },
                        { label: "BUY RATE", isHidden: false, align: 'right' },
                        { label: "SALE RATE", isHidden: false, align: 'right' },
                        { label: "STATUS", isHidden: false },
                    ]}
                >
                    {this.state.InventoryList.map((service, idx) => (
                        <TableRow
                            key={idx}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            <TableCell>{service.ItemType}</TableCell>
                            <TableCell>{service.ItemBrand}</TableCell>
                            <TableCell>{service.ItemName}</TableCell>
                            <TableCell>{service.ItemIMEI}</TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.ItemRate)}</strong></TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.ItemSellRate)}</strong></TableCell>
                            <TableCell><StatusChip label={service.ItemStatus} /></TableCell>
                            <TableCell align='center'>
                                <RowActions actions={[
                                    { type: 'edit', onClick: this.handleOpenModal.bind(this, idx) },
                                ]} />
                            </TableCell>
                        </TableRow>
                    ))}
                </PhoneClinicGrid>
                <Modal
                    show={this.state.showModal}
                    onHide={() => { this.setState({ showModal: false }) }}
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Device Detail
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Type</Form.Label>
                                    <Form.Control
                                        name={"ItemType"}
                                        disabled
                                       
                                        defaultValue={showData['ItemType']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <Form.Control
                                        name={"ItemBrand"}
                                        disabled
                                       
                                        defaultValue={showData['ItemBrand']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Item</Form.Label>
                                    <Form.Control
                                        name={"ItemName"}
                                        disabled
                                       
                                        defaultValue={showData['ItemName']}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Buy Rate</Form.Label>
                                    <AmountInput
                                        name={"ItemRate"}
                                        disabled
                                        defaultValue={showData["ItemRate"]}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Sell Rate</Form.Label>
                                    <AmountInput
                                        name={"ItemSellRate"}
                                        disabled
                                        defaultValue={showData["ItemSellRate"]}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Status</Form.Label>
                                    <Form.Control
                                        name={"ItemStatus"}
                                        disabled
                                        defaultValue={showData["ItemStatus"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>IMEI No / Barcode</Form.Label>
                                    <Form.Control
                                        name={"ItemIMEI"}
                                        disabled
                                        defaultValue={showData["ItemIMEI"]}
                                       
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        name={"ItemDesc"}
                                        disabled
                                        defaultValue={showData["ItemDesc"]}
                                       
                                        type={"textarea"}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Label>Barcode IMEI</Form.Label>
                                <div ref={el => (this.printLabel = el)} >
                                    <Bardcode
                                        value={showData["ItemIMEI"]}
                                        width={this.state.width}
                                        height={this.state.height}
                                        displayValue={this.state.displayValue}
                                        text={this.state.text}
                                        fontOptions={this.state.fontOptions}
                                        font={this.state.font}
                                        textAlign={this.state.textAlign}
                                        textPosition={this.state.textPosition}
                                        textMargin={this.state.textMargin}
                                        fontSize={this.state.fontSize}
                                        background={this.state.background}
                                        lineColor={this.state.lineColor}
                                        margin={this.state.margin}
                                        marginTop={this.state.marginTop}
                                        marginBottom={this.state.marginBottom}
                                        marginLeft={this.state.marginLeft}
                                        marginRight={this.state.marginRight}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <ReactToPrint
                            trigger={() => { return <Button>Print IMEI</Button>; }}
                            content={() => this.printLabel}
                        />
                    </Modal.Footer>
                </Modal>
            </Container >
        );
    }
}

export default Devices;